const availableLocales = ['ar','en']

export {availableLocales}
